const formattedMessagesArray: any = {
  'Invalid Card Number, failed Mod 10 validation': 'Número de tarjeta incorrecto. Por favor, verifícalo y vuelve a intentarlo.',
  'Invalid Expiration Date': 'La fecha de vencimiento de la tarjeta no es válida.',
  'PAYW-2008': 'La tarjeta ha expirado',
  'Insufficient Funds': 'Fondos insuficientes en la tarjeta.',
};




export const formatErrorMessage = (message: string) => {
return formattedMessagesArray[message] || 'Ocurrió un error. Por favor, inténtalo de nuevo más tarde.'

}